import React, { useRef, useEffect, useState } from 'react'
import useCasinoTransactionsList from './hooks/useCasinoTransactionsList'
import { Button, Col, Row, Form } from '@themesberg/react-bootstrap'
import DateRangePicker from '../../../components/DateRangePicker'
import { transactionType, betStatus, sportsBookTransactionTypes } from './constants'
import CasinoTransactionsList from '../../../components/SportsBookTable'

import { downloadFile } from '../../../utils/fileDownloader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt, faFileDownload } from '@fortawesome/free-solid-svg-icons'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import { CustomCol } from '../TransactionsBanking/style'
import { tableCasinotransactionColumns } from "./constants"
import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from "../../../components/TableErrorMessage";
import DateFilterDropdown from "../../../components/CustomDateFilterOptions";


const SportsBookTransactions = ({ isPlayerData, playerData, tabRef, selectedTab }) => {
  console.log({ isPlayerData, playerData }, "isPlayerData, playerData")
  const {
    allCurrencies,
    setSelectedCurrency,
    setSearch,
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    setSelectedAction,
    selectedCurrency,
    selectedAction,
    selectedslipStatus,
    search,
    state,
    setState,
    sportsBookTransactions,
    loading,
    status,
    setStatus,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    getCsvDownloadUrl,
    handleDownload,
    setselectedslipStatus,
    setSearchBetSlip,
    searchbetSlip,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    totalCount
  } = useCasinoTransactionsList({ playerData })

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
    resetColumns

  } = useTableCustom(sportsBookTransactions?.rows,
    tableCasinotransactionColumns,
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "sports_book_transactions");



  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("60vh");
  console.log(state, "statestate")
  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;
      const tabHeight = tabRef?.current?.offsetHeight || 0;


      const responsiveTable = document.querySelector('.table-scroll-wrapper');
      const totalHeight = headerHeight + filterHeight + paginationHeight + tabHeight;
      const availableHeight = window.innerHeight - totalHeight - 120;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        console.log(tabHeight, "tabHeighttabHeighttabHeighttabHeight", { headerHeight, filterHeight, paginationHeight, tabHeight, availableHeight, sportsBookTransactions, loading, visibleColumns })

        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
      }

      setTableMaxHeight(`${availableHeight}px`);

    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [sportsBookTransactions, loading, visibleColumns.length, selectedTab]);



  // console.log(filterRef.current?.offsetHeight || 0, tableMaxHeight , "tabHeighttabHeighttabHeighttabHeight >>>>>>>. out side" )


  return (
    <>
      {!isPlayerData && <div className='section-header-wrap mt-0 mx-n3'>
        <Row className='align-items-center justify-content-between' ref={headerRef}>
          <Col>
            <h2 className='title-text'>Sports Book Transactions</h2>
          </Col>
          <Col xs={2} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>}

      <div className="FormsBg" ref={filterRef}>
        <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>
          <CustomCol xs={12} md={3} lg={2}>
            <Form.Select
              size="sm"
              onChange={(e) => setSelectedAction(e.target.value)}
              value={selectedAction}
              className="mb-2 mb-md-0"
            >
              {transactionType && transactionType?.map(
                ({ label, value }) => (
                  <option key={label} value={value}>
                    {label}
                  </option>
                )
              )}
            </Form.Select>
          </CustomCol>

          {!isPlayerData && <CustomCol xs={12} md={4} lg={2}>
            <Form.Control
              size="sm"
              type="search"
              value={search}
              placeholder="Search by Email"
              onChange={e =>
                setSearch(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
              className="mb-2 mb-md-0"
            />
          </CustomCol>}

          <CustomCol xs={12} md={3} lg={2}>
            <DateFilterDropdown state={state}
              setState={setState} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </CustomCol>



          {selectedFilter === "custom" && <CustomCol xs={12} md={3} lg={3}>
            <DateRangePicker
              state={state}
              setState={setState}
              size="sm"
              className="mb-2 mb-md-0"
              isMAXwidth={true}
            />
          </CustomCol>}

          <CustomCol xs={12} md={4} lg={2}>
            <Form.Control
              size="sm"
              type="search"
              value={searchbetSlip}
              placeholder="Search by Event"
              onChange={e =>
                setSearchBetSlip(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
              className="mb-2 mb-md-0"
            />
          </CustomCol>

          <CustomCol xs={12} md={3} lg={2}>
            <Form.Select
              size="sm"
              onChange={(e) => setselectedslipStatus(e.target.value)}
              value={selectedslipStatus}
              className="mb-2 mb-md-0"
            >
              {betStatus && betStatus?.map(
                ({ label, value }) => (
                  <option key={label} value={value}>
                    {label}
                  </option>
                )
              )}
            </Form.Select>
          </CustomCol>




          <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col xs={12}>
              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 w-100">
                <div>
                  {/* Left: Reset Button */}
                  <Button
                    className="d-flex align-items-center btn-primary gap-3 w-auto"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    onClick={() => {
                      setSearch('');
                      setSelectedAction('all');
                      setSelectedCurrency('');
                      setSelectedClient('');
                      setLimit(15);
                      setPage(1);
                      onResetDateFiltered();
                      // setSelectedFilter("this_month")
                      // setState([{ startDate: null, endDate: null, key: 'selection' }]);
                      setStatus('all');
                      setselectedslipStatus('all');
                      setSearchBetSlip("");
                      resetColumns();
                    }}
                  >
                    <span>Reset Filters</span>
                    <FontAwesomeIcon icon={faRedoAlt} />
                  </Button>
                </div>
                {/* Right: Columns + Download */}
                <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center">
                  <div>{customColSetting}</div>

                  <Button
                    className="d-flex align-items-center btn-primary gap-2"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    disabled={sportsBookTransactions?.count === 0}
                    onClick={() => handleDownload('csv', 'Sports book transactions.csv')}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    <span>Download CSV</span>
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </div>

      {visibleColumns?.length > 0 ? <CasinoTransactionsList
        page={page}
        setLimit={setLimit}
        limit={limit}
        setPage={setPage}
        totalPages={totalPages}
        transactions={sportsBookTransactions}
        isTenant={false}
        loading={loading}
        tableMaxHeight={tableMaxHeight}
        paginationRef={paginationRef}
        visibleColumns={visibleColumns}
        istoggleColumn={true}
        sportsBookTransactionTypes={sportsBookTransactionTypes}

        showTotalCount={true}
        totalCount={totalCount}
        countText={"Total Sports Book Transactions : "}

      /> : <div>
        <TableErrorMessage />
      </div>}
    </>
  )
}

export default SportsBookTransactions
